const DAY_IN_MS = 24 * 60 * 60 * 1000;

function padDatePart(value: number): string {
  return value.toString().padStart(2, '0');
}

function toTimestamp(value: number | string | null | undefined): number | null {
  if (value === null || value === undefined || value === '') return null;

  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  const numericTimestamp = Number(value);
  if (Number.isFinite(numericTimestamp)) return numericTimestamp;

  const parsedDate = new Date(value);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate.getTime();
}

export function isUtcMidnightTimestamp(value: number | string | null | undefined): boolean {
  const timestamp = toTimestamp(value);
  if (timestamp === null) return false;

  return ((timestamp % DAY_IN_MS) + DAY_IN_MS) % DAY_IN_MS === 0;
}

export function getUtcDateOnlyTimestamp(date: Date | null | undefined): number | null {
  if (!date || Number.isNaN(date.getTime())) return null;

  return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
}

export function getDateOnlyDisplayDate(value: number | string | null | undefined): Date | null {
  const timestamp = toTimestamp(value);
  if (timestamp === null) return null;

  const sourceDate = new Date(timestamp);
  if (Number.isNaN(sourceDate.getTime())) return null;

  if (isUtcMidnightTimestamp(timestamp)) {
    return new Date(sourceDate.getUTCFullYear(), sourceDate.getUTCMonth(), sourceDate.getUTCDate());
  }

  return sourceDate;
}

export function getDateOnlyKey(value: number | string | null | undefined): string {
  const timestamp = toTimestamp(value);
  if (timestamp === null) return '';

  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return '';

  if (isUtcMidnightTimestamp(timestamp)) {
    return `${date.getUTCFullYear()}-${padDatePart(date.getUTCMonth() + 1)}-${padDatePart(date.getUTCDate())}`;
  }

  return `${date.getFullYear()}-${padDatePart(date.getMonth() + 1)}-${padDatePart(date.getDate())}`;
}

export function getDateOnlyRangeStart(value: number | string | null | undefined): number | null {
  const key = getDateOnlyKey(value);
  if (key === '') return null;

  return Date.parse(`${key}T00:00:00.000Z`);
}

export function getDateOnlyRangeEndExclusive(value: number | string | null | undefined): number | null {
  const start = getDateOnlyRangeStart(value);
  if (start === null) return null;

  return start + DAY_IN_MS;
}
